jQuery(document).ready(function () {
  if ($(".exempleprofil").length > 0) {
    const getVisualDiv = $(".exempleprofil_visual");
    const getTextDiv = $(".exempleprofil_coloredBackground");

    const getImg = getVisualDiv.attr("data-background");

    const getTextDivHeight= getTextDiv.outerHeight();
    
    getVisualDiv.css("background-image", "url("+getImg+")");
    getVisualDiv.css("height", getTextDivHeight);
  }
});
